import React from 'react';
import { BRAND } from '../data/content';
const links = [{
  label: 'La collezione',
  href: '#collection'
}, {
  label: 'Acquista',
  href: '#offer'
}, {
  label: 'Termini',
  href: '#offer'
}, {
  label: 'Privacy',
  href: '#offer'
}, {
  label: 'Contatti',
  href: '#offer'
}];
export function Footer() {
  return <footer className="bg-ink px-4 pb-32 sm:px-5 sm:pb-14" data-id="element-77" data-mp="36qhh702ou83u">
      <div className="mx-auto max-w-4xl border-t border-cream/15 pt-8 text-center sm:pt-9" data-id="element-78" data-mp="3uf0nxb63actt">
        <p className="display text-[13px] tracking-[0.08em] text-cream sm:text-sm" data-id="element-79" data-mp="3ud7czjog16g0">
          {BRAND}
        </p>
        <nav aria-label="Footer" className="mt-5" data-id="element-80" data-mp="3lem0a55nkln5">
          <ul className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2.5 text-xs font-bold text-cream/55" data-id="element-81" data-mp="3ldu34pweqfur">
            {links.map(link => <li key={link.label} data-id="element-82" data-mp="29z6woiixuvj2">
                <a href={link.href} className="inline-block py-1 transition-colors duration-150 ease-snap hover:text-sun" data-id="element-83" data-mp="29y5fdwbbxcsw">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>
        <p className="mx-auto mt-6 max-w-2xl text-[11px] font-semibold leading-relaxed text-cream/40 sm:mt-7" data-id="element-84" data-mp="3la288r748xtn">
          Prodotto digitale consegnato via email. I risultati dipendono da come
          il materiale viene usato a casa. Questo sito non è affiliato a nessuna
          piattaforma social. © {new Date().getFullYear()}{' '}
          {BRAND.toUpperCase()} — Tutti i diritti riservati.
        </p>
      </div>
    </footer>;
}